import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../services/api'

// Obtener preferencias del servidor
export const fetchPreferencias = createAsyncThunk(
  'preferencias/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/preferencias')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error al obtener preferencias')
    }
  }
)

// Actualizar preferencia específica
export const updatePreferencia = createAsyncThunk(
  'preferencias/update',
  async ({ key, value }, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/preferencias/${key}`, { value })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error al actualizar preferencia')
    }
  }
)

// Actualizar múltiples preferencias
export const updatePreferencias = createAsyncThunk(
  'preferencias/updateMultiple',
  async (preferencias, { rejectWithValue }) => {
    try {
      const response = await api.put('/preferencias', preferencias)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error al actualizar preferencias')
    }
  }
)

const initialState = {
  data: {},
  loading: false,
  error: null,
  initialized: false
}

const preferenciasSlice = createSlice({
  name: 'preferencias',
  initialState,
  reducers: {
    clearPreferencias: (state) => {
      state.data = {}
      state.initialized = false
    },
    setPreferenciaLocal: (state, action) => {
      // Para actualizar localmente mientras se guarda en servidor
      const { key, value } = action.payload
      state.data[key] = value
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchPreferencias.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchPreferencias.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload?.data || {}
        state.initialized = true
      })
      .addCase(fetchPreferencias.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
        state.initialized = true
      })
      // Update single
      .addCase(updatePreferencia.fulfilled, (state, action) => {
        state.data = action.payload?.data || state.data
      })
      // Update multiple
      .addCase(updatePreferencias.fulfilled, (state, action) => {
        state.data = action.payload?.data || state.data
      })
  }
})

export const { clearPreferencias, setPreferenciaLocal } = preferenciasSlice.actions
export default preferenciasSlice.reducer
